import { StateUtils } from '@spartacus/core';
import { Cutting } from '../../../../../core/model';
import { CartEntryCuttingActionTypes } from '../actions/cart-entry-cutting.action';
import { CartActions } from '../actions/index';

export const initialState: Cutting = undefined;

export function reducer(state = initialState, action: CartActions.CartEntryCuttingActions | StateUtils.LoaderAction): Cutting {
  switch (action.type) {
    case CartEntryCuttingActionTypes.CalculateCuttingPriceFail: {
      return initialState;
    }
    case CartEntryCuttingActionTypes.CalculateCuttingPriceSuccess: {
      return action.payload ? action.payload.result : initialState;
    }
  }
  return state;
}
